export default __webpack_public_path__ + "static/media/Group.d165e721.svg";